import PusherClient from 'pusher-js'
import {getCookie} from "cookies-next";

let pusherClient = null;

if (typeof window !== "undefined") {
    pusherClient = new PusherClient(process.env.NEXT_PUBLIC_PUSHER_KEY, {
        cluster: process.env.NEXT_PUBLIC_PUSHER_CLUSTER,
        authEndpoint: process.env.NEXT_PUBLIC_PUSHER_AUTH_URL,
        auth: {
            headers: {
                'Authorization': `Bearer ${getCookie('jwt')}`,
            }
        },
    });
}

export { pusherClient };
